import React from 'react';
import { Button, Grid } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { usePagedList } from '../../../hooks/use-paged-list';
import { useQuestionAnswerSearchController } from './context/question-answer-search-controller';
import { useQuestionAnswerSearchState } from './context/question-answer-search-context';
import QuestionAnswerAppService from '../../../application/platform/apm/question-answer/question-answer-app-service';
import { htmlToPlainText } from '../components/html-utils';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { lookupOptions } from '../../../utils/filter-options';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction } from '../../../components/row-actions';
import { QuestionAnswerDrawer } from './components/question-answer-drawer';

export function QuestionAnswerSearchComponent() {
    const ctrl = useQuestionAnswerSearchController();
    const { parameters, searchTrigger, categories, drawer } = useQuestionAnswerSearchState();
    const list = usePagedList(QuestionAnswerAppService.list, parameters, searchTrigger, 'Não foi possível carregar as perguntas');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'question', headerName: 'Pergunta', flex: 1, minWidth: 260 },
        { field: 'answer', headerName: 'Resposta', flex: 1, minWidth: 260, sortable: false, valueGetter: (params) => htmlToPlainText(params.row.answer) },
        { field: 'category', headerName: 'Categoria', width: 200 },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                    <DeleteAction onClick={() => ctrl.handleDelete(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Perguntas e Respostas"
                    subtitle="Mantenha as perguntas frequentes exibidas no portal"
                    breadcrumbs={[{ label: 'Perguntas e Respostas' }]}
                    actions={<Button variant="outlined" startIcon={<CategoryIcon />} onClick={ctrl.navigateToCategories}>Categorias</Button>}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={8}>
                        <FilterInput label="Pergunta ou resposta" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FilterSelect label="Categoria" name="select-category" value={parameters.categoryId} options={lookupOptions(categories)} emptyLabel="Todas" onChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Nova Pergunta"
                    onAdd={() => ctrl.openDrawer()}
                />
            </Grid>

            <QuestionAnswerDrawer
                open={drawer.open}
                initial={drawer.questionAnswer}
                categories={categories}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
                onManageCategories={ctrl.navigateToCategories}
            />
        </React.Fragment>
    );
}
